var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAddedSugar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 214.66"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.12 147v-6.88a22.41 22.41 0 0022.39-22.39h6.88A29.3 29.3 0 01104.12 147zM66.44 131.67a39.86 39.86 0 018.86-42.81l28.13-28.13 17 17 4.87-4.86L103.43 51l-33 33a46.72 46.72 0 00-9.21 52.88z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.75 90.11a39.78 39.78 0 01-56.2 56.2l-4.86 4.86a46.64 46.64 0 0065.92-65.92zM49.908 155.713l94.59-94.59 4.865 4.865-94.59 94.59z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h200v214.66H0z"
  })));
}
export default SvgNoAddedSugar;